const dropdownSelector = '[data-store-hours-dropdown]';

if (!document.documentElement.dataset.storeHoursDropdownReady) {
  document.documentElement.dataset.storeHoursDropdownReady = 'true';

  document.addEventListener('click', (event) => {
    document.querySelectorAll(dropdownSelector).forEach((dropdown) => {
      if (dropdown.open && !dropdown.contains(event.target)) {
        dropdown.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${dropdownSelector}[open]`).forEach((dropdown) => {
      dropdown.removeAttribute('open');
      dropdown.querySelector('summary')?.focus();
    });
  });
}
